package com.nonopn.skywatcher.common.app.pages.map.model

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Icon
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.nonopn.icons.Pin
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetection
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.maps.XY
import eu.codlab.compose.widgets.TextNormal
import ovh.plrapps.mapcompose.ui.state.MapState

sealed class Composer<T>(
    protected val mapState: MapState,
    protected val flushCallouts: () -> Unit
) {
    @Composable
    fun cluster(size: Int) {
        /* Here we can customize the cluster style */
        Box(
            modifier = Modifier
                .background(AppColor.BackgroundDarkBlueSemiTransparent, shape = CircleShape)
                .size(50.dp),
            contentAlignment = Alignment.Center
        ) {
            TextNormal(
                text = size.toString(),
                color = AppColor.WhiteCream,
                fontSize = 12.sp
            )
        }
    }

    abstract fun compose(model: T, xy: XY, onSelected: (T) -> Unit): @Composable () -> Unit
}

class ComposeProbeHolder(
    mapState: MapState,
    flushCallouts: () -> Unit
) : Composer<ThunderDetection>(mapState, flushCallouts) {
    override fun compose(
        model: ThunderDetection,
        xy: XY,
        onSelected: (ThunderDetection) -> Unit
    ): @Composable (() -> Unit) {
        val id = "${model.latitude}${model.longitude}_callout"
        return {
            Column(
                // normally 22 x 30
                Modifier.width(14.dp).height(20.dp)
                    .clickable {
                        flushCallouts()
                        onSelected(model)
                    }
            ) {
                Icon(
                    painter = rememberVectorPainter(Icons.Rounded.Pin),
                    contentDescription = "Thunder Detection",
                    tint = AppColor.White,
                )
            }
        }
    }
}